// removed by extract-text-webpack-plugin
module.exports = {"poolHeader":"index__poolHeader___3F5_n","tagsContainer":"index__tagsContainer___3l0ZT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/SelectionPool/index.less
// module id = 492
// module chunks = 3